module.exports = __webpack_public_path__ + "media/images/bg/shapes/ecru/2-e187f096e3fe141b30bea4d0a2a7bb04.svg";